import { render, staticRenderFns } from "./PacienteFichaCabecalho.vue?vue&type=template&id=5a1c5c5e&scoped=true"
import script from "./PacienteFichaCabecalho.vue?vue&type=script&lang=js"
export * from "./PacienteFichaCabecalho.vue?vue&type=script&lang=js"
import style0 from "./PacienteFichaCabecalho.vue?vue&type=style&index=0&id=5a1c5c5e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1c5c5e",
  null
  
)

export default component.exports